module.exports = __webpack_public_path__ + "static/media/en.94f62e30.png";